import type { NewsBanner } from '@/types/radio'

function NewsInlineBanner({ banner }: { banner: NewsBanner }) {
  if (!banner?.mediaUrl) return null

  const media =
    banner.mediaType === 'video' ? (
      <video
        src={banner.mediaUrl}
        className="h-full w-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        controls={false}
      />
    ) : (
      <img src={banner.mediaUrl} alt={banner.title || 'Publicidade'} className="h-full w-full object-cover" />
    )

  const frame = (
    <div className="relative mx-auto w-full max-w-[790px] overflow-hidden rounded-xl bg-slate-200 shadow-md">
      <span className="absolute left-2 top-2 z-10 rounded bg-black/75 px-2 py-0.5 text-[9px] font-black uppercase tracking-[0.16em] text-white">
        Banner entre matérias
      </span>
      <div className="aspect-[790/150] w-full">{media}</div>
    </div>
  )

  if (banner.linkUrl) {
    return (
      <a href={banner.linkUrl} target="_blank" rel="noreferrer" className="block" aria-label={banner.title || 'Banner entre matérias'}>
        {frame}
      </a>
    )
  }

  return <div>{frame}</div>
}

export default NewsInlineBanner
